export default __webpack_public_path__ + "static/media/desktop-hero-swedish.70e975ff.svg";